import { render, staticRenderFns } from "./InsertCodeContent.vue?vue&type=template&id=3486b168&scoped=true&"
import script from "./InsertCodeContent.vue?vue&type=script&lang=js&"
export * from "./InsertCodeContent.vue?vue&type=script&lang=js&"
import style0 from "./InsertCodeContent.vue?vue&type=style&index=0&id=3486b168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486b168",
  null
  
)

export default component.exports